/**
 * StudentFormModal — Модалка создания ученика.
 *
 * Обязательно только Имя. Фамилия, отчество, дата рождения, школа — опционально.
 */
import React, { useState, useEffect } from 'react';
import { Modal, TextInput, Textarea, Stack, Group, Button } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { notifications } from '@mantine/notifications';
import { createStudent } from '../../services/api/studentsService';

const StudentFormModal = ({ opened, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    first_name: '', last_name: '', middle_name: '',
    date_of_birth: null, school: '', notes: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (opened) {
      setForm({ first_name: '', last_name: '', middle_name: '', date_of_birth: null, school: '', notes: '' });
    }
  }, [opened]);

  const handleSubmit = async () => {
    if (!form.first_name.trim()) {
      notifications.show({ title: 'Ошибка', message: 'Имя обязательно', color: 'red' });
      return;
    }

    setLoading(true);
    try {
      const data = {
        first_name: form.first_name.trim(),
        ...(form.last_name.trim() && { last_name: form.last_name.trim() }),
        ...(form.middle_name.trim() && { middle_name: form.middle_name.trim() }),
        ...(form.date_of_birth && { date_of_birth: form.date_of_birth.toISOString().split('T')[0] }),
        ...(form.school.trim() && { school: form.school.trim() }),
        ...(form.notes.trim() && { notes: form.notes.trim() }),
      };

      await createStudent(data);
      notifications.show({ title: 'Успешно', message: 'Ученик создан', color: 'green' });
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      notifications.show({ title: 'Ошибка', message: err.message, color: 'red' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Добавить ученика" centered>
      <Stack gap="sm">
        <Group grow>
          <TextInput
            label="Имя"
            placeholder="Имя *"
            required
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
            radius="xl"
          />
          <TextInput
            label="Фамилия"
            placeholder="Фамилия"
            value={form.last_name}
            onChange={(e) => setForm({ ...form, last_name: e.target.value })}
            radius="xl"
          />
        </Group>
        <TextInput
          label="Отчество"
          placeholder="Отчество"
          value={form.middle_name}
          onChange={(e) => setForm({ ...form, middle_name: e.target.value })}
          radius="xl"
        />
        <Group grow>
          <DatePickerInput
            label="Дата рождения"
            placeholder="Выберите дату"
            value={form.date_of_birth}
            onChange={(val) => setForm({ ...form, date_of_birth: val })}
            radius="xl"
            maxDate={new Date()}
            locale="ru"
            clearable
            valueFormat="DD.MM.YYYY"
          />
          <TextInput
            label="Школа"
            placeholder="Школа"
            value={form.school}
            onChange={(e) => setForm({ ...form, school: e.target.value })}
            radius="xl"
          />
        </Group>
        <Textarea
          label="Заметки"
          placeholder="Дополнительная информация"
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
          radius="xl"
        />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onClose}>Отмена</Button>
          <Button onClick={handleSubmit} loading={loading}>Создать</Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default StudentFormModal;
